const GIS_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

/** The tag, if a previous caller (or the host page) already added it. */
const existingTag = () =>
  document.querySelector<HTMLScriptElement>(`script[src="${GIS_SCRIPT_SRC}"]`);

/**
 * Load Google Identity Services once. Resolves when `window.google.accounts.id` can be used (or the
 * script finished loading); rejects when the script cannot load (ad blocker, offline, a strict CSP).
 * A FAILED tag is removed, since it never fires another event: leaving it made every later attempt
 * wait on it forever.
 */
export function loadGisScript(): Promise<void> {
  if (typeof window === "undefined") return Promise.reject(new Error("gsi: no window"));
  if (window.google?.accounts?.id) return Promise.resolve();
  return new Promise<void>((resolve, reject) => {
    const script = existingTag() ?? document.createElement("script");
    script.addEventListener("load", () => resolve(), { once: true });
    script.addEventListener(
      "error",
      () => {
        script.remove();
        reject(new Error("gsi: script failed to load"));
      },
      { once: true },
    );
    if (!script.isConnected) {
      script.src = GIS_SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });
}
